import React, { useEffect } from "react";
// Ya no necesitamos 'useNavigate' si usamos window.location.replace
import { useLocation } from "react-router-dom"; 
import { Box, CircularProgress, Typography } from '@mui/material';
// No necesitas importar axios en este componente, ya que el interceptor
// lo leerá cuando la página se recargue.

export default function AuthCallback() {
  // const navigate = useNavigate(); // Eliminado
  const location = useLocation(); // Hook para leer la URL

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    
    // 1. Extraer los datos de la URL
    const token = params.get('token');
    const name = params.get('name');
    const role = params.get('role');
    const email = params.get('email');
    
    if (token) {
        // 2. Guardar los datos en sessionStorage
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('name', name);
        sessionStorage.setItem('role', role);
        sessionStorage.setItem('email', email);
        
        // 3. Forzar la recarga completa para asegurar que el interceptor de Axios
        // lea el nuevo token del sessionStorage.
        window.location.replace('/'); 

    } else {
        // Manejar el caso de error de login social
        console.error("No se recibió token del backend.");
        // Si no hay token, redirigimos al login (aquí sí se podría usar navigate
        // si lo importaramos, pero por simplicidad, usaremos la redirección de JS)
        window.location.replace('/login?error=social_auth_failed');
    }
    
  // Quitamos 'navigate' de las dependencias
  }, [location]); 

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2 }}>
            Autenticando...
        </Typography>
    </Box>
  );
}